module.exports = __webpack_public_path__ + "_/public/catch-logo2.png?3d3dfa6e";


//////////////////
// WEBPACK FOOTER
// ../public/catch-logo2.png
// module id = 1630
// module chunks = 0